// T22.258: place createPie's hover `.tooltip` (position: fixed) at a VIEWPORT
// point, even when an ancestor is transformed.
//
// The Gallery card lifts on hover (`transform: translateY(-3px)`, see
// WheelListing/FoldersV2/styles.js). A transformed ancestor becomes the
// containing block of a position:fixed descendant, so `left: clientX` was
// measured from the CARD's corner, not the viewport's. The tooltip landed
// ~one card-offset to the right (x=2883 on a 1728px screen), off screen, and
// widened the Gallery's scroll column -> a horizontal scroll bar with nothing
// to scroll to, the moment any wheel was hovered.
//
// Fix: measure where left:0/top:0 actually lands (the containing block's
// origin, (0,0) when nothing is transformed) and subtract it. Then clamp the
// box horizontally inside the viewport AND every scrolling ancestor's client
// box, so a long title near the right edge can never poke past it and grow a
// scroll bar either. (overflow:hidden boxes are skipped: they cannot grow a
// scroll bar, and the card's own hidden wheel frame sits BELOW the tooltip's
// containing block, so it does not clip the tooltip anyway.)

const scrollsX = (el) =>
  /auto|scroll|overlay/.test(window.getComputedStyle(el).overflowX);

function horizontalBounds(node) {
  let left = 0;
  let right =
    window.innerWidth || document.documentElement.clientWidth || Infinity;
  for (
    let el = node.parentElement;
    el && el !== document.body && el !== document.documentElement;
    el = el.parentElement
  ) {
    if (!scrollsX(el)) continue;
    const r = el.getBoundingClientRect();
    if (!r.width) continue;
    const boxLeft = r.left + el.clientLeft;
    left = Math.max(left, boxLeft);
    right = Math.min(right, boxLeft + el.clientWidth);
  }
  return { left, right };
}

export function placeFixedTooltip(node, viewportX, viewportY) {
  if (!node) return { left: viewportX, top: viewportY };
  const width = node.offsetWidth || 0;

  let x = viewportX;
  const bounds = horizontalBounds(node);
  if (bounds.right - bounds.left >= width) {
    x = Math.min(Math.max(x, bounds.left), bounds.right - width);
  }

  node.style.left = "0px";
  node.style.top = "0px";
  const origin = node.getBoundingClientRect();
  const left = x - (origin.left || 0);
  const top = viewportY - (origin.top || 0);
  node.style.left = left + "px";
  node.style.top = top + "px";
  return { left, top };
}
